import React from "react";

import PageHero from "../../components/common/PageHero";
import PageSectionHeader from "../../components/common/PageSectionHeader";
import ScrollIndicator from "../Home/ScrollIndicator";
import useScrollToTop from "../../hooks/useScollToTop";

import PublicationDetail from "./components/PublicationDetail";
import PublicationLightbox from "./components/PublicationLightbox";
import PublicationsEmptyState from "./components/PublicationsEmptyState";
import PublicationsSkeleton from "./components/PublicationsSkeleton";
import PublicationsSummary from "./components/PublicationsSummary";

import { PUBLICATIONS_PAGE } from "./data/publicationsUiData";
import { usePublicationsPage } from "./hooks/usePublicationsPage";

export default function PublicationsPage() {
  useScrollToTop();

  const {
    loading,
    error,
    publications,
    total,
    selectedPublication,
    selectedId,
    zoomImage,
    selectPublication,
    openZoom,
    closeZoom,
    refresh,
  } = usePublicationsPage();

  return (
    <>
      <PageHero
        title={PUBLICATIONS_PAGE.title}
        imageUrl={PUBLICATIONS_PAGE.heroImageUrl}
        crumbs={PUBLICATIONS_PAGE.crumbs}
      />

      <ScrollIndicator />

      <main className="mx-auto max-w-[1240px] px-4 pb-16 pt-6 sm:px-6 md:pt-8">
        <PageSectionHeader
          eyebrow={PUBLICATIONS_PAGE.eyebrow}
          title={PUBLICATIONS_PAGE.title}
          description={PUBLICATIONS_PAGE.description}
        >
          <div className="rounded-3xl border border-slate-200 bg-white/80 px-5 py-4 shadow-sm backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Publications actives
            </p>
            <p className="mt-1 text-3xl font-bold text-slate-950 dark:text-white">
              {loading ? "…" : total}
            </p>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              document{total > 1 ? "s" : ""} disponible
              {total > 1 ? "s" : ""}
            </p>
          </div>
        </PageSectionHeader>

        {error && (
          <div className="mt-5 rounded-3xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-semibold text-red-700 dark:border-red-900/60 dark:bg-red-950/30 dark:text-red-300">
            Une erreur est survenue pendant le chargement des publications.
          </div>
        )}

        <section className="mt-6 space-y-6">
          {loading ? (
            <PublicationsSkeleton />
          ) : publications.length > 0 ? (
            <>
              <PublicationsSummary
                loading={loading}
                publications={publications}
                selectedId={selectedId}
                onSelect={selectPublication}
                onRefresh={refresh}
              />

              <PublicationDetail
                publication={selectedPublication}
                onZoom={openZoom}
              />
            </>
          ) : (
            <PublicationsEmptyState />
          )}
        </section>
      </main>

      <PublicationLightbox
        publication={selectedPublication}
        isOpen={zoomImage}
        onClose={closeZoom}
      />
    </>
  );
}